import { render, staticRenderFns } from "./CheckFcsAgreement.vue?vue&type=template&id=bf474462&scoped=true"
import script from "./CheckFcsAgreement.vue?vue&type=script&lang=js"
export * from "./CheckFcsAgreement.vue?vue&type=script&lang=js"
import style0 from "./CheckFcsAgreement.vue?vue&type=style&index=0&id=bf474462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf474462",
  null
  
)

export default component.exports